module.exports = __webpack_public_path__ + "img/_Compound Path2.93e602d7.png";